import { observable, runInAction } from "mobx";

export const showConfettiState = observable.box(false);

export const showConfetti = () => {
  setTimeout(
    () =>
      runInAction(() => {
        showConfettiState.set(true);
      }),
    500,
  );

  setTimeout(() => {
    runInAction(() => {
      showConfettiState.set(false);
    });
  }, 5500);
};
